import {
  OcpwSurveyDataObject,
  LegalLots,
  AlignmentNotes,
  CertificateOfCompliance,
  CityAnnexation,
  CityTies,
  CornerRecords,
  CountySurveyorTieBooks,
  FloodChannelsAndAsBuilts,
  HorizontalControl,
  JackRaubNotes,
  LotLineAdjustment,
  MiscellaneousDocuments,
  MiscellaneousRecordsLA,
  MonumentRecords,
  OcfcdFieldNotes,
  Ocrtn,
  ParcelMap,
  RecordsOfSurvey,
  RoadDeed,
  SurveyFieldNotes,
  SurveyorMaps,
  TractMap,
  TopographicSurveys,
  VerticalControlPoints,
  Encumbrances,
  FloodParcels,
  MiscFacilities,
  ParkParcels,
  RoadParcels,
} from "./DataModels";

export const OcpwSurveyGetLinkList = (
  OCLandInsightsDictionary,
  layerTitle: string,
  attributes,
  download = false
): any[] => {
  const layerConfiguration = [
    new LegalLots(OCLandInsightsDictionary["parcels"]),
    new AlignmentNotes(OCLandInsightsDictionary["alignmentNotes"]),
    new CertificateOfCompliance(
      OCLandInsightsDictionary["certificateOfCompliance"]
    ),
    new CityAnnexation(OCLandInsightsDictionary["cityAnnexations"]),
    new CityTies(OCLandInsightsDictionary["cityTies"]),
    new CornerRecords(OCLandInsightsDictionary["cornerRecords"]),
    new CountySurveyorTieBooks(
      OCLandInsightsDictionary["countySurveyorTieBooks"]
    ),
    new FloodChannelsAndAsBuilts(
      OCLandInsightsDictionary["floodChannelsAndAsBuilts"]
    ),
    new HorizontalControl(OCLandInsightsDictionary["horizontalControlPoints"]),
    new JackRaubNotes(OCLandInsightsDictionary["jackRaubNotes"]),
    new LotLineAdjustment(OCLandInsightsDictionary["lotLineAdjustments"]),
    new OcfcdFieldNotes(OCLandInsightsDictionary["ocfcdFieldNotes"]),
    new Ocrtn(OCLandInsightsDictionary["ocrtn"]),
    new MiscellaneousDocuments(
      OCLandInsightsDictionary["miscellaneousDocuments"]
    ),
    new MiscellaneousRecordsLA(
      OCLandInsightsDictionary["miscellaneousRecordsLA"]
    ),
    new MonumentRecords(OCLandInsightsDictionary["monumentRecords"]),
    new ParcelMap(OCLandInsightsDictionary["parcelMaps"]),
    new RoadDeed(OCLandInsightsDictionary["roadDeeds"]),
    new RecordsOfSurvey(OCLandInsightsDictionary["recordsOfSurvey"]),
    new SurveyFieldNotes(OCLandInsightsDictionary["surveyFieldNotes"]),
    new SurveyorMaps(OCLandInsightsDictionary["surveyorMaps"]),
    new TractMap(OCLandInsightsDictionary["tractMaps"]),
    new TopographicSurveys(OCLandInsightsDictionary["topographicSurveys"]),
    new VerticalControlPoints(
      OCLandInsightsDictionary["verticalControlPoints"]
    ),
    new Encumbrances(OCLandInsightsDictionary["encumbrances"]),
    new FloodParcels(OCLandInsightsDictionary["floodParcels"]),
    new MiscFacilities(OCLandInsightsDictionary["miscFacilities"]),
    new ParkParcels(OCLandInsightsDictionary["parkParcels"]),
    new RoadParcels(OCLandInsightsDictionary["roadParcels"]),
  ];
  let list = [];
  layerConfiguration.forEach((config: OcpwSurveyDataObject) => {
    if (layerTitle === config.title) {
      list = config.getDocumentArray(attributes, download);
    } else {
      return [];
    }
  });
  return list;
};
